/**
 * @generated SignedSource<<16df421031b278f472e0d349ca293524>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DuplicateNovaAgentInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DuplicateNovaAgentMutation$variables = {
  input: DuplicateNovaAgentInput;
};
export type DuplicateNovaAgentMutation$data = {
  readonly duplicateNovaAgent: {
    readonly agent: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly title: string | null;
        readonly description: string | null;
        readonly categoryId: string | null;
      } | null;
    } | null;
  } | null;
};
export type DuplicateNovaAgentMutation = {
  variables: DuplicateNovaAgentMutation$variables;
  response: DuplicateNovaAgentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DuplicateNovaAgentPayload",
    "kind": "LinkedField",
    "name": "duplicateNovaAgent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgentEdge",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgent",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DuplicateNovaAgentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DuplicateNovaAgentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0c360f77b154da9e3e1d62427a6502ed",
    "id": null,
    "metadata": {},
    "name": "DuplicateNovaAgentMutation",
    "operationKind": "mutation",
    "text": "mutation DuplicateNovaAgentMutation(\n  $input: DuplicateNovaAgentInput!\n) {\n  duplicateNovaAgent(input: $input) {\n    agent {\n      node {\n        id\n        name\n        title\n        description\n        categoryId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "42205c4df5e91bf3d30d4431c692b68d";

export default node;
